
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $10337c4271bcd7f5$export$6a66c0f713e1ad72(element, wrapperTag = 'div', options = {}) {
    if (!element || !(element instanceof HTMLElement)) throw new Error('First parameter must be a valid HTMLElement');
    const wrapper = document.createElement(wrapperTag);
    if (options.id) wrapper.id = options.id;
    if (options.className) wrapper.classList.add(...Array.isArray(options.className) ? options.className : options.className.trim().split(/\s+/));
    if (options.attributes && typeof options.attributes === 'object') Object.entries(options.attributes).forEach(([key, value])=>{
        wrapper.setAttribute(key, value);
    });
    if (options.dataset && typeof options.dataset === 'object') Object.entries(options.dataset).forEach(([key, value])=>{
        wrapper.dataset[key] = value;
    });
    if (options.styles && typeof options.styles === 'object') Object.entries(options.styles).forEach(([property, value])=>{
        wrapper.style[property] = value;
    });
    if (options.events && typeof options.events === 'object') Object.entries(options.events).forEach(([eventType, handler])=>{
        if (typeof handler === 'function') wrapper.addEventListener(eventType, handler);
    });
    if (options.textContent) wrapper.textContent = options.textContent;
    const parent = element.parentNode;
    if (parent) parent.insertBefore(wrapper, element);
    if (options.prepend) wrapper.insertBefore(element, wrapper.firstChild);
    else wrapper.appendChild(element);
    if (Array.isArray(options.children)) options.children.forEach((child)=>{
        if (child instanceof HTMLElement) wrapper.appendChild(child);
    });
    if (options.innerHTML) wrapper.innerHTML = options.prepend ? options.innerHTML + wrapper.innerHTML : wrapper.innerHTML + options.innerHTML;
    return wrapper;
}
function $10337c4271bcd7f5$export$e3003f5a97cb6c20(element, options = {}) {
    if (!element || !(element instanceof HTMLElement)) throw new Error('First parameter must be a valid HTMLElement');
    const specialProps = [
        'className',
        'attributes',
        'dataset',
        'styles',
        'events',
        'textContent',
        'innerHTML',
        'children'
    ];
    // Set all direct properties except the special ones
    Object.entries(options).forEach(([prop, value])=>{
        if (specialProps.includes(prop)) return;
        try {
            element[prop] = value;
        } catch  {
            console.warn(`Failed to set property "${prop}" on element`, value);
        }
    });
    if (options.className) element.classList.add(...Array.isArray(options.className) ? options.className : options.className.trim().split(/\s+/));
    if (options.attributes && typeof options.attributes === 'object') Object.entries(options.attributes).forEach(([key, value])=>{
        element.setAttribute(key, value);
    });
    if (options.dataset && typeof options.dataset === 'object') Object.entries(options.dataset).forEach(([key, value])=>{
        element.dataset[key] = value;
    });
    if (options.styles && typeof options.styles === 'object') Object.entries(options.styles).forEach(([key, value])=>{
        element.style[key] = value;
    });
    if (options.events && typeof options.events === 'object') Object.entries(options.events).forEach(([eventType, handler])=>{
        if (typeof handler === 'function') element.addEventListener(eventType, handler);
    });
    if (options.textContent) element.textContent = options.textContent;
    if (options.innerHTML) element.innerHTML = options.innerHTML;
    if (Array.isArray(options.children)) options.children.forEach((child)=>{
        if (child instanceof HTMLElement) element.appendChild(child);
    });
    return element;
}


function $6f65527eeb86a1bc$export$f0ecb95e2885bc42() {
    const logo = document.createElement('a');
    logo.className = 'logo-picture';
    logo.innerHTML = `
        <img src="https://cdn.gauas.online/images/internship/logo.svg" alt="Logo" class="logo-image" style="width: 100px; display: block;">
    `;
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(logo, {
        id: 'logo',
        events: {
            click: ()=>window.location.href = '/'
        },
        dataset: {
            component: 'logo'
        },
        target: '_self',
        rel: 'noopener noreferrer',
        ariaLabel: 'Go to homepage',
        className: [
            'logo',
            'p-2'
        ]
    });
}



function $0b5c186865dd8c3c$export$33c44f651bf6b4db() {
    const git = document.createElement('div');
    git.className = 'github-button';
    git.innerHTML = `
      <a class="Github Repository" href="https://github.com/tnqbao/internship-practice-js" aria-label="GitHub Repository" target="_blank" rel="noopener noreferrer">
        <img src="https://cdn.gauas.online/images/internship/github-icon.svg" alt="GitHub Icon">
      </a>
  `;
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(git, {
        id: 'github-repo-button',
        events: {
            mouseenter: (e)=>e.target.style.transform = 'scale(1.1)',
            mouseleave: (e)=>e.target.style.transform = 'scale(1)'
        },
        dataset: {
            component: 'github-button'
        }
    });
}



function $95c4b6dc5cf3dccc$export$4732515547ee1d19() {
    const author = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
        className: [
            'author',
            'text-sm',
            'font-bold',
            'color-secondary'
        ],
        id: 'author',
        textContent: 'Author: Tran Nguyen Quoc Bao',
        dataset: {
            component: 'author'
        }
    });
    const email = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('a'), {
        className: [
            'email',
            'text-sm'
        ],
        id: 'email',
        innerHTML: `
        <img src="https://cdn.gauas.online/images/internship/email-icon.svg" alt="Email Icon" width="30px" height="30px">
        `,
        href: 'mailto:qquocbao.job106204@gmail.com',
        dataset: {
            component: 'email'
        },
        target: '_blank',
        rel: 'noopener noreferrer',
        ariaLabel: 'Email to Tran Nguyen Quoc Bao',
        events: {
            mouseenter: (e)=>e.target.style.transform = 'scale(1.1)',
            mouseleave: (e)=>e.target.style.transform = 'scale(1)'
        }
    });
    const phone_number = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('a'), {
        className: [
            'phone-number',
            'text-sm'
        ],
        id: 'phone-number',
        innerHTML: `
        <img src="https://cdn.gauas.online/images/internship/phone-call-icon.svg" alt="Phone Icon" width="30px" height="30px">
        `,
        href: 'tel:+84367641617',
        dataset: {
            component: 'phone-number'
        },
        target: '_blank',
        rel: 'noopener noreferrer',
        ariaLabel: 'Call Tran Nguyen Quoc Bao',
        events: {
            mouseenter: (e)=>e.target.style.transform = 'scale(1.1)',
            mouseleave: (e)=>e.target.style.transform = 'scale(1)'
        }
    });
    const linkedIn = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('a'), {
        className: [
            'linked-in',
            'text-sm'
        ],
        id: 'linked-in',
        innerHTML: `
        <img src="https://cdn.gauas.online/images/internship/linkedin-icon.svg" alt="LinkedIn Icon" width="30px" height="30px">
        `,
        href: 'https://www.linkedin.com/in/tnqb2004/',
        target: '_blank',
        rel: 'noopener noreferrer',
        ariaLabel: 'LinkedIn profile of Tran Nguyen Quoc Bao',
        dataset: {
            component: 'linked-in'
        }
    });
    const referencesInformation = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'references-information',
            'flex',
            'flex-col',
            'gap-4'
        ],
        id: 'references-information',
        children: [
            email,
            phone_number,
            linkedIn
        ]
    });
    const headerInfo = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'header-information',
            'flex',
            'w-full',
            'flex-1',
            'justify-between',
            'items-center',
            'container'
        ],
        id: 'header-information',
        children: [
            author,
            referencesInformation
        ]
    });
    return (0, $10337c4271bcd7f5$export$6a66c0f713e1ad72)(headerInfo, 'div', {
        className: [
            'header-information-wrapper',
            'flex',
            'w-full',
            'justify-between',
            'items-center',
            'flex-1',
            'p-sm'
        ]
    });
}




function $09f8f36c40dab729$export$1b7c1833b7e4a6c3(logo, repositoryButton) {
    const headerNavbar = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'header-navbar',
            'flex',
            'container',
            'justify-between',
            'items-center',
            'gap-4',
            'w-full',
            'flex-1',
            'container',
            'p-sm'
        ],
        id: 'header-navbar',
        dataset: {
            component: 'header-navbar'
        },
        children: [
            logo,
            repositoryButton
        ]
    });
    return (0, $10337c4271bcd7f5$export$6a66c0f713e1ad72)(headerNavbar, 'div', {
        className: [
            'header-navbar-wrapper',
            'flex',
            'w-full',
            'flex-1',
            'bg-secondary'
        ]
    });
}


class $da4e5fc0baa30f10$export$59ff7196be1562f4 {
    constructor(controller){
        if (new.target === $da4e5fc0baa30f10$export$59ff7196be1562f4) throw new Error('AbstractView is an abstract class and cannot be instantiated directly');
        this.controller = controller;
        this.model = null;
    }
    // Abstract methods - must be implemented by subclasses
    render() {
        throw new Error('render() method must be implemented by subclass');
    }
    updateDisplay(data) {
        console.log(data);
        throw new Error('updateDisplay() method must be implemented by subclass');
    }
    showValidationError(field, message) {
        throw new Error('showValidationError() method must be implemented by subclass');
    }
    showResult(result) {
        throw new Error('showResult() method must be implemented by subclass');
    }
    // Common interface methods
    bindModel(model) {
        this.model = model;
    }
    onModelChange(property, newValue, oldValue) {
        this.updateDisplay(this.model);
    }
    onDataChange(modelData) {
        this.updateDisplay(modelData);
    }
    onValidationError(field, message) {
        this.showValidationError(field, message);
    }
    // Template method pattern
    initialize() {
        this.setupView();
        return this.render();
    }
    setupView() {
    // Default setup - can be overridden
    }
    destroy() {
        this.controller = null;
        this.model = null;
    }
}


class $ced081e41ba2e0f1$export$9ea0601e6d601bb7 extends (0, $da4e5fc0baa30f10$export$59ff7196be1562f4) {
    constructor(controller){
        super(controller);
        this.elements = {};
    }
    updateDisplay(data) {
        if (data) this.updateFormFields(data);
    }
    showValidationError(field, message) {
        console.warn(`DOM View - ${field}: ${message}`);
        this.highlightErrorField(field);
    }
    showResult(result) {
        this.displayBMIResult(result);
    }
    // DOM-specific helper methods
    createElement(tag, options = {}) {
        const element = document.createElement(tag);
        if (options.className) element.className = Array.isArray(options.className) ? options.className.join(' ') : options.className;
        if (options.textContent) element.textContent = options.textContent;
        if (options.innerHTML) element.innerHTML = options.innerHTML;
        if (options.id) element.id = options.id;
        return element;
    }
    updateFieldValidation(fieldName, isValid) {
        const input = this.elements[`${fieldName}Input`];
        if (input) {
            input.classList.toggle('valid', isValid);
            input.classList.toggle('invalid', !isValid);
        }
    }
    highlightErrorField(field) {
        const input = this.elements[`${field}Input`];
        if (input) {
            input.classList.add('error');
            setTimeout(()=>input.classList.remove('error'), 3000);
        }
    }
    updateFormFields(data) {}
    displayBMIResult(result) {}
    destroy() {
        super.destroy();
        this.elements = {};
    }
}


function $9c3e0cdbb908598f$export$798e69447a57ffe5(controller = null) {
    class HeaderView extends (0, $ced081e41ba2e0f1$export$9ea0601e6d601bb7) {
        constructor(controller){
            super(controller);
            this.isInitialized = false;
        }
        updateFormFields(data) {}
        displayBMIResult(result) {}
        showResult(result) {}
        #createHeaderComponents() {
            const headerInfo = (0, $95c4b6dc5cf3dccc$export$4732515547ee1d19)();
            const logo = (0, $6f65527eeb86a1bc$export$f0ecb95e2885bc42)();
            const repositoryButton = (0, $0b5c186865dd8c3c$export$33c44f651bf6b4db)();
            const headerNavbar = (0, $09f8f36c40dab729$export$1b7c1833b7e4a6c3)(logo, repositoryButton);
            this.elements.headerInfo = headerInfo;
            this.elements.logo = logo;
            this.elements.repositoryButton = repositoryButton;
            this.elements.headerNavbar = headerNavbar;
            return {
                headerInfo: headerInfo,
                headerNavbar: headerNavbar
            };
        }
        render() {
            const { headerInfo: headerInfo, headerNavbar: headerNavbar } = this.#createHeaderComponents();
            const header = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('header'), {
                className: [
                    'header',
                    'flex',
                    'flex-wrap',
                    'justify-between',
                    'items-center',
                    'bg-gray-800',
                    'text-white'
                ],
                id: 'header',
                dataset: {
                    component: 'header-view'
                },
                children: [
                    headerInfo,
                    headerNavbar
                ]
            });
            this.elements.header = header;
            this.isInitialized = true;
            return header;
        }
        isInitialized() {
            return this.isInitialized;
        }
    }
    const headerView = new HeaderView();
    if (controller && typeof controller.registerView === 'function') controller.registerView('header', headerView);
    return headerView.render();
}





function $731fa2aa36cb248b$export$7c88f7b87167f6(controller = null) {
    class FooterView extends (0, $ced081e41ba2e0f1$export$9ea0601e6d601bb7) {
        constructor(controller){
            super(controller);
            this.elements = {};
            this.isInitialized = false;
        }
        updateFormFields(data) {}
        displayBMIResult(result) {}
        showResult(result) {}
        #createPhoneContact() {
            const phoneContact = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'phone-contact',
                    'flex',
                    'items-center',
                    'gap-2'
                ],
                id: 'phone-contact',
                innerHTML: `
                <div class="phone-icon flex items-center justify-center">
                    <img src="https://cdn.gauas.online/images/internship/phone.svg" alt="phone-button"/>
                </div>
                <span class="phone-number text-xxl">1900 1717</span>
                `
            });
            this.elements.phoneNumber = phoneContact.querySelector('.phone-number');
            return phoneContact;
        }
        #createReferencesInformation() {
            const phoneContact = this.#createPhoneContact();
            const referencesInformation = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'references-information',
                    'flex',
                    'flex-col',
                    'gap-4'
                ],
                id: 'references-information',
                children: [
                    phoneContact
                ]
            });
            this.elements.referencesInfo = referencesInformation;
            return referencesInformation;
        }
        #createFooterInfo() {
            const logo = (0, $6f65527eeb86a1bc$export$f0ecb95e2885bc42)();
            const referencesInformation = this.#createReferencesInformation();
            const footerInfo = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'footer-information',
                    'flex',
                    'container',
                    'w-full',
                    'flex-1',
                    'justify-between',
                    'items-center'
                ],
                id: 'footer-information',
                children: [
                    logo,
                    referencesInformation
                ]
            });
            this.elements.logo = logo;
            this.elements.footerInfo = footerInfo;
            return footerInfo;
        }
        render() {
            const footerInfo = this.#createFooterInfo();
            const footerWrapper = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'footer-information-wrapper',
                    'flex',
                    'flex-col',
                    'items-center',
                    'justify-center',
                    'w-full',
                    'p-md'
                ],
                id: 'footer',
                children: [
                    footerInfo
                ]
            });
            this.isInitialized = true;
            return footerWrapper;
        }
        isInitialized() {
            return this.isInitialized;
        }
    }
    const footerView = new FooterView();
    if (controller && typeof controller.registerView === 'function') controller.registerView('footer', footerView);
    return footerView.render();
}




function $2ace3b651ae1e43e$export$ab7d0030ce754acf() {
    const maleButton = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('button'), {
        id: 'male-button',
        className: [
            'male-button',
            'flex',
            'flex-2',
            'bg-secondary',
            'justify-center',
            'items-center',
            'gap-2',
            'border-0',
            'p-sm',
            'active'
        ],
        innerHTML: `
        <img src="https://cdn.gauas.online/images/internship/male-icon.svg" alt="Male Icon">
        <span>Male</span>            
        `,
        events: {
            click: (event)=>{
                event.preventDefault();
                document.getElementById('male-button').classList.add('active');
                document.getElementById('female-button').classList.remove('active');
            }
        }
    });
    const femaleButton = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('button'), {
        id: 'female-button',
        className: [
            'female-button',
            'flex',
            'flex-2',
            'bg-secondary',
            'justify-center',
            'items-center',
            'gap-2',
            'border-0',
            'p-sm',
            'rounded'
        ],
        innerHTML: `
        <img src="https://cdn.gauas.online/images/internship/female-icon.svg" alt="Female Icon">
        <span>Female</span>
    `,
        events: {
            click: (event)=>{
                event.preventDefault();
                document.getElementById('female-button').classList.add('active');
                document.getElementById('male-button').classList.remove('active');
            }
        }
    });
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'gender-toggle',
            'flex',
            'w-full',
            'flex-1',
            'justify-center',
            'items-center',
            'gap-1',
            'm-b-lg',
            'p-sm',
            'bg-tertiary',
            'rounded-6'
        ],
        id: 'gender-toggle',
        children: [
            maleButton,
            femaleButton
        ]
    });
}


var $fcdafb58c0dbb5ab$exports = {};
$fcdafb58c0dbb5ab$exports = JSON.parse("{\"metric\":{\"height\":{\"min\":30,\"max\":250},\"weight\":{\"min\":0.5,\"max\":300}},\"imperial\":{\"height\":{\"min\":11.8,\"max\":98.4},\"weight\":{\"min\":1.1,\"max\":661.4}}}");




function $0d2336714dd975ea$export$3115d2a8d273cf6b(handleAgeChange) {
    const today = new Date();
    const maxDate = new Date(today.getFullYear() - 200, today.getMonth(), today.getDate());
    const maxDateString = maxDate.toISOString().split('T')[0];
    const todayString = today.toISOString().split('T')[0];
    const ageField = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'flex',
            'flex-col',
            'flex-1',
            'flex-wrap',
            'm-b-sm'
        ],
        children: [
            (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('label'), {
                className: [
                    'text-primary',
                    'p-x-sm'
                ],
                htmlFor: 'age-input',
                innerHTML: '<h3 class="text-secondary">Date of Birth</h3>'
            }),
            (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('input'), {
                type: 'date',
                className: [
                    'age-input',
                    'flex',
                    'flex-1',
                    'w-full',
                    'p-sm',
                    'm-b-sm',
                    'border',
                    'rounded-1'
                ],
                id: 'age-input',
                dataset: {
                    component: 'age-input'
                },
                min: maxDateString,
                max: todayString,
                events: {
                    change: (event)=>handleAgeChange(event.target.value)
                }
            })
        ]
    });
    return ageField;
}




function $a3daf72339c78bbc$export$fa7b3194642b60f8(handleHeightChange, currentUnit = 'metric') {
    const rules = (0, (/*@__PURE__*/$parcel$interopDefault($fcdafb58c0dbb5ab$exports)))[currentUnit];
    const heightField = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'flex',
            'flex-col',
            'flex-1',
            'flex-wrap',
            'm-b-md'
        ],
        children: [
            (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('label'), {
                className: [
                    'text-primary',
                    'p-x-sm'
                ],
                htmlFor: 'height-input',
                innerHTML: '<h3 class="text-secondary">Height</h3>'
            }),
            (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('input'), {
                type: 'number',
                className: [
                    'height-input',
                    'flex',
                    'flex-1',
                    'w-full',
                    'p-sm',
                    'm-b-sm',
                    'border',
                    'rounded-1'
                ],
                placeholder: 'Enter your height',
                id: 'height-input',
                dataset: {
                    component: 'height-input'
                },
                step: 0.1,
                min: rules.height.min,
                max: rules.height.max,
                events: {
                    input: (event)=>handleHeightChange(event.target.value),
                    change: (event)=>handleHeightChange(event.target.value)
                }
            })
        ]
    });
    return heightField;
}




function $b60e2cd43b536b18$export$efde758b7d3eef76(handleWeightChange, currentUnit = 'metric') {
    const rules = (0, (/*@__PURE__*/$parcel$interopDefault($fcdafb58c0dbb5ab$exports)))[currentUnit];
    const weightField = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'flex',
            'flex-col',
            'flex-1',
            'flex-wrap',
            'm-b-xs'
        ],
        children: [
            (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('label'), {
                className: [
                    'text-primary',
                    'p-x-sm'
                ],
                htmlFor: 'weight-input',
                innerHTML: '<h3 class="text-secondary">Weight</h3>'
            }),
            (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('input'), {
                type: 'number',
                className: [
                    'weight-input',
                    'flex',
                    'flex-1',
                    'w-full',
                    'p-sm',
                    'm-b-lg',
                    'border',
                    'rounded-1'
                ],
                placeholder: 'Enter your weight',
                id: 'weight-input',
                dataset: {
                    component: 'weight-input'
                },
                step: 0.1,
                min: rules.weight.min,
                max: rules.weight.max,
                events: {
                    input: (event)=>handleWeightChange(event.target.value),
                    change: (event)=>handleWeightChange(event.target.value)
                }
            })
        ]
    });
    return weightField;
}


function $11d472eb5a5cd0cc$export$33cde6b33eca4e5(controller) {
    class FormView extends (0, $ced081e41ba2e0f1$export$9ea0601e6d601bb7) {
        constructor(controller){
            super(controller);
            this.currentUnit = 'metric';
        }
        onUnitChange(newUnit) {
            this.currentUnit = newUnit;
            this.#updateValidationRules();
        }
        updateDisplay(modelData) {
            this.#updateFormValidation(modelData);
        }
        showValidationError(field, message) {
            super.showValidationError(field, message);
        }
        updateFormFields(data) {
            if (data) {
                this.updateFieldValidation('height', data.height > 0);
                this.updateFieldValidation('weight', data.weight > 0);
                this.updateFieldValidation('age', data.age > 0);
            }
        }
        #handleHeightChange(value) {
            if (value && !isNaN(value)) this.controller.updateHeight(parseFloat(value));
        }
        #handleWeightChange(value) {
            if (value && !isNaN(value)) this.controller.updateWeight(parseFloat(value));
        }
        #handleAgeChange(dateOfBirth) {
            if (dateOfBirth) this.controller.updateAge(dateOfBirth);
        }
        #handleUnitToggle() {
            this.controller.toggleUnit();
        }
        #handleCalculate() {
            this.controller.calculateBMI();
        }
        #updateValidationRules() {
            const heightInput = this.elements.heightInput;
            const weightInput = this.elements.weightInput;
            if (heightInput && weightInput) {
                const rules = (0, (/*@__PURE__*/$parcel$interopDefault($fcdafb58c0dbb5ab$exports)))[this.currentUnit];
                heightInput.min = rules.height.min;
                heightInput.max = rules.height.max;
                weightInput.min = rules.weight.min;
                weightInput.max = rules.weight.max;
            }
        }
        #updateFormValidation(modelData) {
            this.updateFieldValidation('height', modelData.height > 0);
            this.updateFieldValidation('weight', modelData.weight > 0);
            this.updateFieldValidation('age', modelData.age > 0);
        }
        #createUnitToggleButton() {
            const unitToggleButton = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('button'), {
                className: [
                    'unit-toggle-button',
                    'flex',
                    'w-half',
                    'flex-center',
                    'bg-secondary',
                    'color-primary',
                    'p-sm',
                    'rounded',
                    'mt-4'
                ],
                innerHTML: '<span id="unit-toggle-text">Switch to Imperial</span>',
                id: 'unit-toggle-button',
                dataset: {
                    component: 'unit-toggle-button',
                    currentUnit: 'metric'
                },
                events: {
                    click: (event)=>{
                        event.preventDefault();
                        this.#handleUnitToggle();
                    }
                }
            });
            this.elements.toggleButton = unitToggleButton;
            return unitToggleButton;
        }
        #createCalculateButton() {
            const calculateButton = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('button'), {
                className: [
                    'calculate-button',
                    'flex',
                    'w-half',
                    'flex-center',
                    'bg-primary',
                    'color-secondary',
                    'p-sm',
                    'rounded',
                    'mt-4'
                ],
                innerHTML: '<span>Calculate BMI</span>',
                id: 'calculate-button',
                dataset: {
                    component: 'calculate-button'
                },
                events: {
                    click: (event)=>{
                        event.preventDefault();
                        this.#handleCalculate();
                    }
                }
            });
            this.elements.calculateButton = calculateButton;
            return calculateButton;
        }
        render() {
            const genderToggle = (0, $2ace3b651ae1e43e$export$ab7d0030ce754acf)();
            const ageField = (0, $0d2336714dd975ea$export$3115d2a8d273cf6b)(this.#handleAgeChange.bind(this));
            const heightField = (0, $a3daf72339c78bbc$export$fa7b3194642b60f8)(this.#handleHeightChange.bind(this), this.currentUnit);
            const weightField = (0, $b60e2cd43b536b18$export$efde758b7d3eef76)(this.#handleWeightChange.bind(this), this.currentUnit);
            const calculateButton = this.#createCalculateButton();
            const unitToggleButton = this.#createUnitToggleButton();
            this.elements.ageInput = ageField.querySelector('#age-input');
            this.elements.heightInput = heightField.querySelector('#height-input');
            this.elements.weightInput = weightField.querySelector('#weight-input');
            const formWrapper = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'bmi-form-wrapper',
                    'flex',
                    'flex-col',
                    'container',
                    'flex-wrap',
                    'items-center',
                    'justify-center',
                    'w-full',
                    'h-full',
                    'p-lg',
                    'rounded-6',
                    'gap-sm'
                ],
                id: 'form-view',
                dataset: {
                    component: 'form-view'
                },
                children: [
                    genderToggle,
                    ageField,
                    weightField,
                    heightField,
                    calculateButton,
                    unitToggleButton
                ]
            });
            this.isInitialized = true;
            return formWrapper;
        }
    }
    const formView = new FormView(controller);
    controller.registerView('form', formView);
    return formView.render();
}




var $722ca2ee64e4098c$exports = {};
$722ca2ee64e4098c$exports = JSON.parse('[{"id":"severe-thinness","label":"Severe Thinness","min":0,"max":16,"color":"#fe0100","description":"Severe thinness can lead to a compromised immune system, increased susceptibility to infections, anemia, osteoporosis, muscle wasting, menstrual irregularities in females, and psychological issues such as anxiety and depression.","recommendation":[{"title":"Consult with a specialist","description":"Seek assistance from a healthcare provider and nutritionist to establish an appropriate dietary plan, supplement micronutrients, and closely monitor the individual\u2019s health status."},{"title":"Dietary adjustments","description":"Provide a high-calorie and nutrient-dense diet, particularly rich in protein, healthy fats, vitamins, and minerals, to support recovery."},{"title":"Encourage light physical activity","description":" Promote gentle physical activities to help restore muscle mass and maintain overall health."}]},{"id":"thinness","label":"Thinness","min":16,"max":16.9,"color":"#fe9900","description":"Thinness can lead to fatigue, reduced immune function, increased susceptibility to infections, digestive issues, poor nutrient absorption, hair loss, dry skin, and delayed wound healing.","recommendation":[{"title":"Consultation with a physician and nutrition expert","description":"Seek advice from a healthcare provider to determine the underlying causes and develop an appropriate nutritional plan."},{"title":"Nutrient-rich diet","description":"Ensure adequate intake of calories, proteins, healthy fats, vitamins, and minerals. Divide meals into smaller, more frequent portions and prioritize energy-dense foods."},{"title":"Healthy lifestyle","description":"Incorporate light physical activity and ensure sufficient rest and sleep to support overall health and recovery."}]},{"id":"underweight","label":"Underweight","min":17,"max":18.4,"color":"#ffbc7c","description":"Underweight may impact the body\u2019s immune function and recovery capacity.","recommendation":[{"title":"Nutritional improvement","description":"Increase intake of nutrient-dense foods, especially those rich in protein, healthy fats, vitamins, and minerals."},{"title":"Consultation with a physician or nutritionist","description":"Discuss the nutritional status with a healthcare professional and develop a plan for adequate nutrient supplementation."},{"title":"Healthy lifestyle","description":"Ensure adequate sleep, engage in regular physical activity, and manage stress levels to support overall health."}]},{"id":"normal","label":"Normal","min":18.5,"max":24.9,"color":"#01b203","description":"The body is developing proportionally and within a healthy range.","recommendation":[{"title":"Maintain a balanced diet","description":"Continue consuming a variety of nutrient-rich foods, including adequate amounts of protein, healthy fats, vitamins, and minerals to support overall health."},{"title":"Encourage physical activity","description":"Aim for at least 150 minutes of exercise per week, which is recommended for maintaining cardiovascular health and overall well-being."},{"title":"Regular health monitoring","description":"Schedule routine health check-ups to detect potential health issues early and take timely corrective measures if necessary."}]},{"id":"pre-obesity","label":"Pre-obesity","min":25,"max":29.9,"color":"#cc99fe","description":"Pre-obesity increases the risk of developing various health conditions, including type 2 diabetes, high blood pressure, cardiovascular disease, dyslipidemia, fatty liver disease, joint problems, sleep apnea, and certain types of cancer.","recommendation":[{"title":"Dietary adjustments","description":"Reduce the intake of high-calorie, sugary, and unhealthy fat-laden foods. Increase the consumption of vegetables, fruits, whole grains, and lean protein sources to improve nutritional intake and support weight loss."},{"title":"Encourage physical activity","description":"Engage in at least 150 minutes of moderate-intensity exercise per week to help burn calories and maintain a stable weight."},{"title":"Stress and sleep management","description":"Manage stress effectively and ensure sufficient sleep to support the weight loss process and overall well-being."}]},{"id":"class-1-obesity","label":"Class 1 Obesity","min":30,"max":34.9,"color":"#993365","description":"Class 1 obesity increases the risk of developing a variety of health conditions, including type 2 diabetes, cardiovascular disease, high blood pressure, dyslipidemia, fatty liver disease, joint problems, sleep apnea, and certain cancers.","recommendation":[{"title":"Consult a healthcare provider or nutritionist","description":"Schedule an appointment to assess health status and receive guidance on a balanced diet and safe, effective weight loss plan."},{"title":"Dietary modifications","description":"Reduce caloric intake and limit foods high in unhealthy fats. Increase the consumption of vegetables, fruits, and whole grains. Consider smaller, more frequent meals to help control food intake."},{"title":"Promote physical activity","description":"Engage in appropriate physical activities, such as walking, running, swimming, or muscle-strengthening exercises, to burn excess calories and improve overall fitness."}]},{"id":"class-2-obesity","label":"Class 2 Obesity","min":35,"max":39.9,"color":"#81017f","description":"Class 2 obesity significantly increases the risk of developing health conditions such as Type 2 diabetes, cardiovascular disease, hypertension, dyslipidemia, fatty liver disease, joint problems, sleep apnea, stroke, and certain types of cancer.","recommendation":[{"title":"Strict dietary plan","description":"Significantly reduce calorie intake, particularly processed foods, sugars, and unhealthy fats. Increase the consumption of vegetables, fruits, lean proteins, and whole grains."},{"title":"Increase physical activity","description":"Engage in at least 150 minutes of physical exercise each week. Consider consulting a physician or fitness trainer to develop an appropriate exercise plan."},{"title":"Specialized medical consultation","description":"See a doctor to assess the associated health risks. Medical or surgical weight loss interventions may be considered if necessary."}]},{"id":"class-3-obesity","label":"Class 3 Obesity","min":40,"max":999,"color":"#4a0e4e","description":"Class 3 obesity significantly increases the risk of developing serious health conditions such as type 2 diabetes, cardiovascular disease, stroke, sleep apnea, joint problems, and many other serious health issues.","recommendation":[{"title":"Strict and scientific dietary plan","description":"Follow a calorie-restricted diet focused on nutrient-dense foods such as vegetables, fruits, whole grains, and lean proteins."},{"title":"Increase physical activity with supervision","description":"Start with light exercises and gradually increase intensity as directed by a physician or trainer."},{"title":"Specialized medical intervention","description":"Consult a specialist to assess your overall health condition and consider treatment options such as weight loss surgery or pharmacological interventions."}]}]');


function $d42126a547f9a4f3$var$createBmiLine({ id: id, label: label }) {
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        id: `range-${id}`,
        className: [
            'bmi-result-line',
            'w-full',
            'h-4',
            'rounded',
            'transition-all',
            'duration-300'
        ],
        dataset: {
            range: id
        },
        title: label,
        innerHTML: `
            <span class="bmi-result-line"> </span>
            <div class="bmi-arrow range-${id} opacity-0">
                <img src="https://cdn.gauas.online/images/internship/arrow.svg" alt="Arrow Icon" width="20" height="20">
            </div>
        `
    });
}
function $d42126a547f9a4f3$export$53dda4297b86c892() {
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($722ca2ee64e4098c$exports))).map($d42126a547f9a4f3$var$createBmiLine);
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        id: 'bmi-result-path',
        className: [
            'bmi-result-path',
            'flex',
            'w-full',
            'flex-1',
            'justify-center',
            'items-center',
            'gap-1',
            'm-b-lg',
            'p-sm',
            'rounded-6'
        ],
        children: children
    });
}



function $868c60a944765735$export$7f318b9ee1cf5fea() {
    const bmiResultNumberAge = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'bmi-result-number-age',
            'text-secondary'
        ],
        id: 'bmi-result-number-age',
        innerHTML: `
            <p class='color-primary'>
                <h3>
                Age:
                </h3> 
            </p>
            <p id='bmi-result-age' class='color-primary'> 0 Years</p>
        `
    });
    const bmiResultWeightIdeal = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'bmi-result-weight-ideal',
            'text-secondary'
        ],
        id: 'bmi-result-weight-ideal',
        innerHTML: `
            <p class='color-primary'>
                <h3>
                Ideal Weight:
                </h3>
            </p>
            <p id='bmi-result-weight' class='color-primary text-lg'> 0 Kg to 0 Kg</p>
        `
    });
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'bmi-result-ideal',
            'flex',
            'items-center',
            'justify-between',
            'w-full',
            'gap-4',
            'hidden'
        ],
        id: 'bmi-result-ideal',
        children: [
            bmiResultNumberAge,
            bmiResultWeightIdeal
        ]
    });
}



function $1a674d72ec076ef7$export$970b745b7173c03c() {
    const assessmentDesc = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
        className: [
            'bmi-result-assessment-desc',
            'text-secondary'
        ],
        id: 'bmi-result-assessment-desc',
        innerHTML: `
            <span class='color-primary'>
                <strong>
                Assessment:
                </strong> 
            </span>
            <span id='bmi-result-desc-content' class='color-primary'> Normal </span>
        `
    });
    const descriptionSection = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'bmi-result-description-section',
            'text-secondary'
        ],
        id: 'bmi-result-description-section',
        innerHTML: `
            <p id='bmi-result-description' class='text-secondary text-start'>
                The body is developing proportionally and within a healthy range.
            </p>
        `
    });
    const recommendationDesc = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'bmi-result-recommendation-desc',
            'text-secondary'
        ],
        id: 'bmi-result-recommendation-desc',
        innerHTML: `
            <span class='color-primary m-b-2'>
                <strong>
                Recommendations:  
                </strong> 
            </span>
            <ul id='recommendation-list' class="p-l-xl">
            </ul>
        `
    });
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'bmi-result-desc',
            'flex',
            'flex-col',
            'flex-wrap',
            'items-center',
            'justify-between',
            'w-full',
            'gap-4',
            'hidden'
        ],
        id: 'bmi-result-desc',
        children: [
            assessmentDesc,
            descriptionSection,
            recommendationDesc
        ]
    });
}



function $af4cc45e54920a04$export$51c8a1824fe3bae6() {
    const textDefaultContent = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
        className: [
            'text-secondary',
            'text-sm',
            'color-primary',
            'text-center',
            'w-full'
        ],
        innerHTML: `<span>Please enter your birthdate (to calculate age), weight, and gender above to see your BMI.</span>`
    });
    const noteTextContent = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
        className: [
            'text-secondary',
            'text-sm',
            'color-primary',
            'text-center',
            'w-full'
        ],
        innerHTML: `
        <span id='red-note'> Note: </span>
        <span>This tool is applicable for all ages except for pregnant </span>`
    });
    return (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
        className: [
            'bmi-default-content',
            'flex',
            'flex-col',
            'flex-wrap',
            'items-center',
            'justify-between',
            'w-full',
            'gap-4'
        ],
        id: 'bmi-default-content',
        children: [
            textDefaultContent,
            noteTextContent
        ]
    });
}



function $07032ca19aac2ac1$export$33542b22e498cc2(controller = null) {
    class ResultView extends (0, $ced081e41ba2e0f1$export$9ea0601e6d601bb7) {
        constructor(controller){
            super(controller);
            this.elements = {};
        }
        updateFormFields(data) {}
        displayBMIResult(result) {
            if (result && result.bmi) this.showBMIResult(result);
            else this.showDefaultContent();
        }
        showResult(result) {
            this.displayBMIResult(result);
        }
        showBMIResult(result) {
            // Hide default content
            if (this.elements.defaultContent) this.elements.defaultContent.style.display = 'none';
            // Show result components
            if (this.elements.resultNumber) this.elements.resultNumber.classList.remove('hidden');
            if (this.elements.resultPath) this.elements.resultPath.style.display = 'flex';
            // Update BMI value
            if (this.elements.bmiValue) this.elements.bmiValue.textContent = result.bmi.toFixed(1);
            // Update category and description
            if (this.elements.categoryElement && result.category) {
                this.elements.categoryElement.textContent = result.category.label;
                this.elements.categoryElement.style.color = result.category.color;
            }
            // Update ideal weight
            if (this.elements.idealWeightElement && result.idealWeight) this.elements.idealWeightElement.textContent = `${result.idealWeight.min} - ${result.idealWeight.max} ${result.weightUnit}`;
            // Update age
            if (this.elements.ageElement && result.age) this.elements.ageElement.textContent = `${result.age} years`;
        }
        showDefaultContent() {
            // Show default content
            if (this.elements.defaultContent) this.elements.defaultContent.style.display = 'flex';
            // Hide result components
            if (this.elements.resultNumber) this.elements.resultNumber.classList.add('hidden');
            if (this.elements.resultPath) this.elements.resultPath.style.display = 'none';
        }
        #createResultTitle() {
            const resultTitle = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('h2'), {
                id: 'result-default-title',
                className: [
                    'text-center',
                    'mb-4',
                    'font-bold',
                    'color-primary'
                ],
                textContent: 'Your BMI Result'
            });
            this.elements.defaultTitle = resultTitle;
            return resultTitle;
        }
        #createResultNumber() {
            const resultNumber = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'flex',
                    'flex-col',
                    'items-center',
                    'hidden',
                    'justify-center',
                    'gap-2'
                ],
                id: 'result-number',
                children: [
                    (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('h2'), {
                        className: [
                            'text-secondary'
                        ],
                        textContent: 'Your BMI is:'
                    }),
                    (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('h2'), {
                        className: [
                            'font-bold',
                            'text-primary'
                        ],
                        id: 'bmi-value',
                        textContent: '0.0'
                    })
                ]
            });
            this.elements.resultNumber = resultNumber;
            this.elements.bmiValue = resultNumber.querySelector('#bmi-value');
            return resultNumber;
        }
        #createBMIComponents() {
            const resultPath = (0, $d42126a547f9a4f3$export$53dda4297b86c892)();
            const resultIdeal = (0, $868c60a944765735$export$7f318b9ee1cf5fea)();
            const resultDesc = (0, $1a674d72ec076ef7$export$970b745b7173c03c)();
            const defaultContent = (0, $af4cc45e54920a04$export$51c8a1824fe3bae6)();
            this.elements.resultPath = resultPath;
            this.elements.idealWeightElement = resultIdeal.querySelector('#bmi-result-weight');
            this.elements.ageElement = resultIdeal.querySelector('#bmi-result-age');
            this.elements.categoryElement = resultDesc.querySelector('#bmi-result-desc-content');
            this.elements.descriptionElement = resultDesc.querySelector('#bmi-result-description');
            this.elements.recommendationListElement = resultDesc.querySelector('#recommendation-list');
            this.elements.defaultContent = defaultContent;
            return {
                resultPath: resultPath,
                resultIdeal: resultIdeal,
                resultDesc: resultDesc,
                defaultContent: defaultContent
            };
        }
        render() {
            const resultTitle = this.#createResultTitle();
            const resultNumber = this.#createResultNumber();
            const { resultPath: resultPath, resultIdeal: resultIdeal, resultDesc: resultDesc, defaultContent: defaultContent } = this.#createBMIComponents();
            const resultWrapper = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'bmi-result-wrapper',
                    'flex-col',
                    'items-center',
                    'justify-between',
                    'w-full',
                    'h-full',
                    'p-lg',
                    'bg-secondary',
                    'rounded-1'
                ],
                dataset: {
                    component: 'result-view'
                },
                children: [
                    resultTitle,
                    resultNumber,
                    resultPath,
                    resultIdeal,
                    resultDesc,
                    defaultContent
                ]
            });
            this.elements.wrapper = resultWrapper;
            this.isInitialized = true;
            return resultWrapper;
        }
    }
    const resultView = new ResultView(controller);
    if (controller && typeof controller.registerView === 'function') controller.registerView('result', resultView);
    return resultView.render();
}




function $ab9f30044e754e5e$export$463c3a0a10169cf8(controller = null) {
    class InformationView extends (0, $ced081e41ba2e0f1$export$9ea0601e6d601bb7) {
        constructor(controller){
            super(controller);
            this.elements = {};
            this.isInitialized = false;
        }
        updateFormFields(data) {}
        displayBMIResult(result) {}
        showResult(result) {}
        onUnitChange(newUnit) {
            this.#updateFormulaDisplay(newUnit);
        }
        onDataChange(modelData) {
            this.#updateExamples(modelData);
        }
        #updateFormulaDisplay(newUnit) {
            if (this.elements.bmiFormula) this.elements.bmiFormula.innerText = newUnit === 'metric' ? "BMI = weight (kg) / (height (m))\xb2" : "BMI = (weight (lbs) / (height (in))\xb2) \xd7 703";
            if (this.elements.bmiExampleFormula) this.elements.bmiExampleFormula.innerText = newUnit === 'metric' ? "BMI = 55 / (1.75)\xb2 = 17.96" : "BMI = (121 / (69)\xb2) \xd7 703 = 17.87";
        }
        #updateExamples(modelData) {
            if (modelData && modelData.height && modelData.weight) this.#generateDynamicExample(modelData);
        }
        #generateDynamicExample(modelData) {
            if (this.elements.dynamicExample && modelData.height && modelData.weight) {
                const unit = modelData.type;
                this.elements.dynamicExample.innerText = unit === 'metric' ? `With your input: BMI = ${modelData.weight} / (${(modelData.height / 100).toFixed(2)})\xb2 = ${modelData.bmi?.toFixed(2) || 'calculating...'}` : `With your input: BMI = (${modelData.weight} / (${modelData.height})\xb2) \xd7 703 = ${modelData.bmi?.toFixed(2) || 'calculating...'}`;
                this.elements.dynamicExample.classList.remove('hidden');
            }
        }
        #createBMIExplanationWrapper() {
            const bmiExplanationWrapper = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'bmi-info',
                    'text-base',
                    'text-primary',
                    'leading-relaxed',
                    'flex',
                    'flex-col',
                    'gap-4'
                ]
            });
            this.elements.bmiExplanationWrapper = bmiExplanationWrapper;
            return bmiExplanationWrapper;
        }
        #createBMITitle() {
            const bmiTitle = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('h2'), {
                className: [
                    'text-xl',
                    'font-bold'
                ],
                innerText: 'What is BMI?'
            });
            this.elements.bmiTitle = bmiTitle;
            return bmiTitle;
        }
        #createBMIIntro() {
            const bmiIntro = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: `Body Mass Index (BMI) is a simple measurement used to evaluate an individual's weight status by comparing their weight to their height. This tool is widely used by healthcare professionals to provide a general overview of whether an individual is underweight, overweight, or obese, helping to guide dietary and exercise recommendations.`
            });
            this.elements.bmiIntro = bmiIntro;
            return bmiIntro;
        }
        #createBMIHealthRisk() {
            const bmiHealthRisk = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: `A BMI outside the healthy weight range may increase the risk of certain health conditions. For instance, individuals with a BMI in the obese category are at higher risk for type 2 diabetes, cardiovascular diseases, cancer, and other health issues.`
            });
            this.elements.bmiHealthRisk = bmiHealthRisk;
            return bmiHealthRisk;
        }
        #createBMILimitations() {
            const bmiLimitations = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: `However, BMI has limitations, as it does not directly measure body fat mass. It may not be accurate for people with a higher muscle mass, such as athletes, or older adults with muscle loss. It is important to consider BMI alongside other factors such as medical tests, physical exams, and lifestyle habits.`
            });
            this.elements.bmiLimitations = bmiLimitations;
            return bmiLimitations;
        }
        #createBMICalcTitle() {
            const bmiCalcTitle = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('h2'), {
                className: [
                    'text-xl',
                    'font-bold',
                    'pt-4'
                ],
                innerText: 'How to calculate BMI?'
            });
            this.elements.bmiCalcTitle = bmiCalcTitle;
            return bmiCalcTitle;
        }
        #createBMIFormulaText() {
            const bmiFormulaText = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: 'The BMI formula is as follows:'
            });
            this.elements.bmiFormulaText = bmiFormulaText;
            return bmiFormulaText;
        }
        #createBMIFormula() {
            const bmiFormula = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('i'), {
                className: [
                    'text-center'
                ],
                innerText: "BMI = weight (kg) / (height (m))\xb2"
            });
            this.elements.bmiFormula = bmiFormula;
            return bmiFormula;
        }
        #createBMIExampleIntro() {
            const bmiExampleIntro = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: 'For example, if an individual weighs 55 kg and is 1.75 meters tall, the BMI would be:'
            });
            this.elements.bmiExampleIntro = bmiExampleIntro;
            return bmiExampleIntro;
        }
        #createBMIExampleFormula() {
            const bmiExampleFormula = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('i'), {
                className: [
                    'text-center'
                ],
                innerText: "BMI = 55 / (1.75)\xb2 = 17.96"
            });
            this.elements.bmiExampleFormula = bmiExampleFormula;
            return bmiExampleFormula;
        }
        #createWHRIntro() {
            const whrIntro = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: `BMI helps determine if a person is underweight, overweight, or obese, but it does not provide information on where body fat is distributed. To assess fat distribution, the Waist-Hip Ratio (WHR) can be used. The WHR compares the circumference of the waist to the circumference of the hips and is used to evaluate fat distribution across the body. This ratio can help better assess health risks based on whether fat is concentrated around the abdomen or hips.`
            });
            this.elements.whrIntro = whrIntro;
            return whrIntro;
        }
        #createWHRExample() {
            const whrExample = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: `For example, someone with a normal BMI but a high WHR may be at increased risk for heart disease or diabetes due to abdominal fat accumulation. The formula for WHR is:`
            });
            this.elements.whrExample = whrExample;
            return whrExample;
        }
        #createWHRFormula() {
            const whrFormula = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                className: [
                    'italic',
                    'text-center'
                ],
                innerText: 'WHR = waist circumference (cm) / hip circumference (cm)'
            });
            this.elements.whrFormula = whrFormula;
            return whrFormula;
        }
        #createBMIConclusionTitle() {
            const bmiConclusionTitle = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('h2'), {
                className: [
                    'text-xl',
                    'font-bold',
                    'pt-4'
                ],
                innerText: 'Conclusion'
            });
            this.elements.bmiConclusionTitle = bmiConclusionTitle;
            return bmiConclusionTitle;
        }
        #createBMIConclusionText() {
            const bmiConclusionText = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('p'), {
                innerText: `BMI is a simple yet effective tool for evaluating weight status and overall health. However, it should not be the sole measure of health. To achieve a healthy body and avoid health risks, BMI should be considered alongside other testing methods, a balanced diet, and regular exercise.`
            });
            this.elements.bmiConclusionText = bmiConclusionText;
            return bmiConclusionText;
        }
        render() {
            const bmiExplanationWrapper = this.#createBMIExplanationWrapper();
            const bmiTitle = this.#createBMITitle();
            const bmiIntro = this.#createBMIIntro();
            const bmiHealthRisk = this.#createBMIHealthRisk();
            const bmiLimitations = this.#createBMILimitations();
            const bmiCalcTitle = this.#createBMICalcTitle();
            const bmiFormulaText = this.#createBMIFormulaText();
            const bmiFormula = this.#createBMIFormula();
            const bmiExampleIntro = this.#createBMIExampleIntro();
            const bmiExampleFormula = this.#createBMIExampleFormula();
            const whrIntro = this.#createWHRIntro();
            const whrExample = this.#createWHRExample();
            const whrFormula = this.#createWHRFormula();
            const bmiConclusionTitle = this.#createBMIConclusionTitle();
            const bmiConclusionText = this.#createBMIConclusionText();
            const informationWrapper = (0, $10337c4271bcd7f5$export$e3003f5a97cb6c20)(document.createElement('div'), {
                className: [
                    'information-view',
                    'flex',
                    'flex-col',
                    'flex-wrap',
                    'items-center',
                    'justify-start',
                    'w-full',
                    'rounded-xl',
                    'p-lg',
                    'gap-4'
                ],
                id: 'information-view',
                dataset: {
                    component: 'information-view'
                },
                children: [
                    bmiTitle,
                    bmiIntro,
                    bmiHealthRisk,
                    bmiLimitations,
                    bmiCalcTitle,
                    bmiFormulaText,
                    bmiFormula,
                    bmiExampleIntro,
                    bmiExampleFormula,
                    whrIntro,
                    whrExample,
                    whrFormula,
                    bmiConclusionTitle,
                    bmiConclusionText,
                    bmiExplanationWrapper
                ]
            });
            this.elements.wrapper = informationWrapper;
            this.isInitialized = true;
            return informationWrapper;
        }
        isInitialized() {
            return this.isInitialized;
        }
    }
    const informationView = new InformationView(controller);
    if (controller && typeof controller.registerView === 'function') controller.registerView('information', informationView);
    return informationView.render();
}




class $f77e571e6ce32ee3$export$73e7f398ef8270ed {
    calculateBMI(height, weight) {
        // BMI formula requires height in meters; height is provided in centimeters, so divide by 100.
        const heightInMeters = height / 100;
        return weight / heightInMeters ** 2;
    }
    isValid(height, weight) {
        const rule = (0, (/*@__PURE__*/$parcel$interopDefault($fcdafb58c0dbb5ab$exports))).metric;
        return height >= rule.height.min && height <= rule.height.max && weight >= rule.weight.min && weight <= rule.weight.max;
    }
    getIdealWeightRange(height) {
        // 18.5 and 24.9 are chosen because they are the World Health Organization's recommended BMI thresholds for healthy weight.
        const minBMI = 18.5; // lower healthy BMI limit
        const maxBMI = 24.9; // upper healthy BMI limit
        const heightInMeters = height / 100; // convert cm to meters
        return [
            minBMI * heightInMeters * heightInMeters,
            maxBMI * heightInMeters * heightInMeters
        ];
    }
    getUnitType() {
        return 'metric';
    }
    getWeightUnit() {
        return 'kg';
    }
    getHeightUnit() {
        return 'cm';
    }
}



class $6e10f3b8d034c4ec$export$e5a6152c29ed1a80 {
    calculateBMI(height, weight) {
        // 703 is used to convert BMI calculated with imperial units (lbs/in^2) to the standard BMI scale.
        const BMI_CONVERSION_FACTOR = 703;
        return weight / height ** 2 * BMI_CONVERSION_FACTOR;
    }
    isValid(height, weight) {
        const rule = (0, (/*@__PURE__*/$parcel$interopDefault($fcdafb58c0dbb5ab$exports))).imperial;
        return height >= rule.height.min && height <= rule.height.max && weight >= rule.weight.min && weight <= rule.weight.max;
    }
    getIdealWeightRange(height) {
        // 18.5 and 24.9 are chosen because they are the World Health Organization's recommended BMI thresholds for healthy weight.
        const minBMI = 18.5; // lower healthy BMI limit
        const maxBMI = 24.9; // upper healthy BMI limit
        const BMI_CONVERSION_FACTOR = 703; // imperial conversion factor
        return [
            minBMI * height * height / BMI_CONVERSION_FACTOR,
            maxBMI * height * height / BMI_CONVERSION_FACTOR
        ];
    }
    getUnitType() {
        return 'imperial';
    }
    getWeightUnit() {
        return 'lbs';
    }
    getHeightUnit() {
        return 'in';
    }
}


class $3804779a567855a8$export$b95188dfbc2a51d {
    #height = 0;
    #weight = 0;
    #age = 0;
    #type = 'metric';
    #strategy;
    #observers = [];
    #detailedAge;
    constructor({ height: height = 0, weight: weight = 0, age: age = 0, type: type = 'metric' } = {}){
        this.#height = height;
        this.#weight = weight;
        this.#age = age;
        this.#type = type;
        this.#strategy = this.#createStrategy(type);
        this.#observers = [];
    }
    get height() {
        return this.#height;
    }
    set height(value) {
        const numValue = parseFloat(value);
        if (isNaN(numValue) || numValue <= 0) throw new Error('Height must be a positive number');
        this.#height = numValue;
        this.#notifyObservers('height', numValue);
    }
    get weight() {
        return this.#weight;
    }
    set weight(value) {
        const numValue = parseFloat(value);
        if (isNaN(numValue) || numValue <= 0) throw new Error('Weight must be a positive number');
        this.#weight = numValue;
        this.#notifyObservers('weight', numValue);
    }
    get age() {
        return this.#age;
    }
    set age(value) {
        const numValue = parseInt(value);
        if (isNaN(numValue) || numValue <= 0) throw new Error('Age must be a positive number');
        this.#age = numValue;
        this.#notifyObservers('age', numValue);
    }
    get type() {
        return this.#type;
    }
    set type(value) {
        if (![
            'metric',
            'imperial'
        ].includes(value)) throw new Error('Type must be either "metric" or "imperial"');
        const oldType = this.#type;
        this.#type = value;
        this.#strategy = this.#createStrategy(value);
        this.#notifyObservers('type', value, oldType);
    }
    #createStrategy(type) {
        switch(type){
            case 'metric':
                return new (0, $f77e571e6ce32ee3$export$73e7f398ef8270ed)();
            case 'imperial':
                return new (0, $6e10f3b8d034c4ec$export$e5a6152c29ed1a80)();
            default:
                throw new Error(`Unsupported strategy type: ${type}`);
        }
    }
    calculateBMI() {
        if (!this.isDataComplete()) throw new Error('Incomplete data: height, weight, and age are required');
        return this.#strategy.calculateBMI(this.#height, this.#weight);
    }
    getBMICategory() {
        const bmi = this.calculateBMI();
        const matched = (0, (/*@__PURE__*/$parcel$interopDefault($722ca2ee64e4098c$exports))).find((r)=>bmi >= r.min && bmi < r.max);
        return matched ? {
            label: matched.label,
            color: matched.color,
            id: matched.id
        } : {
            label: 'Unknown',
            color: '#ccc',
            id: null
        };
    }
    isValid() {
        return this.isDataComplete() && this.#strategy.isValid(this.#height, this.#weight);
    }
    isDataComplete() {
        return this.#height > 0 && this.#weight > 0 && this.#age > 0;
    }
    getIdealWeightRange() {
        if (!this.#height) throw new Error('Height is required to calculate ideal weight range');
        return this.#strategy.getIdealWeightRange(this.#height);
    }
    getWeightUnit() {
        return this.#strategy.getWeightUnit();
    }
    getHeightUnit() {
        return this.#strategy.getHeightUnit();
    }
    getUnitType() {
        return this.#strategy.getUnitType();
    }
    addObserver(observer) {
        this.#observers.push(observer);
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((obs)=>obs !== observer);
    }
    #notifyObservers(property, newValue, oldValue = null) {
        this.#observers.forEach((observer)=>{
            if (typeof observer.onModelChange === 'function') observer.onModelChange(property, newValue, oldValue);
        });
    }
    convertToUnit(targetUnit) {
        if (this.#type === targetUnit) return;
        if (this.#height > 0) this.#height = this.#convertHeight(this.#height, this.#type, targetUnit);
        if (this.#weight > 0) this.#weight = this.#convertWeight(this.#weight, this.#type, targetUnit);
        this.type = targetUnit;
    }
    #convertHeight(value, fromUnit, toUnit) {
        if (fromUnit === 'metric' && toUnit === 'imperial') return value / 2.54;
        else if (fromUnit === 'imperial' && toUnit === 'metric') return value * 2.54;
        return value;
    }
    #convertWeight(value, fromUnit, toUnit) {
        if (fromUnit === 'metric' && toUnit === 'imperial') return value * 2.20462;
        else if (fromUnit === 'imperial' && toUnit === 'metric') return value / 2.20462;
        return value;
    }
    convertHeight(value, fromUnit, toUnit) {
        return this.#convertHeight(value, fromUnit, toUnit);
    }
    convertWeight(value, fromUnit, toUnit) {
        return this.#convertWeight(value, fromUnit, toUnit);
    }
    calculateAgeFromDateOfBirth(dateOfBirth) {
        if (!dateOfBirth) throw new Error('Date of birth is required');
        // Handle YYYY-MM-DD format from date input
        let year, month, day;
        if (dateOfBirth.includes('-')) // YYYY-MM-DD format
        [year, month, day] = dateOfBirth.split('-').map(Number);
        else if (dateOfBirth.includes('/')) // DD/MM/YYYY format (legacy support)
        [day, month, year] = dateOfBirth.split('/').map(Number);
        else throw new Error('Invalid date format. Use YYYY-MM-DD or DD/MM/YYYY');
        if (!day || !month || !year) throw new Error('Invalid date format');
        const today = new Date();
        const birthDate = new Date(year, month - 1, day);
        // Validate the birth date
        if (birthDate > today) throw new Error('Date of birth cannot be in the future');
        if (year < today.getFullYear() - 200) throw new Error('Age cannot be more than 200 years');
        let age = today.getFullYear() - year;
        const monthDiff = today.getMonth() - (month - 1);
        if (monthDiff < 0 || monthDiff === 0 && today.getDate() < day) age--;
        if (age < 0 || age > 200) throw new Error('Invalid age calculated from date of birth');
        return {
            years: age,
            months: Math.abs(monthDiff)
        };
    }
    setAgeFromDateOfBirth(dateOfBirth) {
        if (!dateOfBirth) throw new Error('Date of birth is required');
        const ageData = this.calculateAgeFromDateOfBirth(dateOfBirth);
        this.#age = ageData.years;
        this.#detailedAge = ageData;
        this.#notifyObservers('age', this.#age);
    }
    getDetailedAge() {
        return this.#detailedAge;
    }
    toJSON() {
        return {
            height: this.#height,
            weight: this.#weight,
            age: this.#age,
            type: this.#type,
            bmi: this.isDataComplete() ? this.calculateBMI() : null,
            category: this.isDataComplete() ? this.getBMICategory() : null,
            isValid: this.isValid()
        };
    }
}


function $46d5fd222f178ba4$export$e3169eee83556da4(controller, model, property, newValue, oldValue) {
    switch(property){
        case 'type':
            controller.toggleUnit?.(); // trigger unit toggle
            break;
        case 'height':
        case 'weight':
        case 'age':
            controller.views?.forEach((view)=>{
                if (typeof view.onDataChange === 'function') view.onDataChange(model.toJSON());
            });
            break;
    }
}


function $1cfd5eadd7a35500$export$14802090cb9157a0(views, field, message) {
    console.warn(`Validation error for ${field}: ${message}`);
    views.forEach((view)=>{
        if (typeof view.onValidationError === 'function') view.onValidationError(field, message);
    });
}
function $1cfd5eadd7a35500$export$d3da1ecaf1206c58(context, error) {
    console.error(`${context}:`, error);
    alert(`${context}. Please try again.`);
}
function $1cfd5eadd7a35500$export$227443268704debe(message) {
    alert(message);
}


function $cab22a0d6aee4804$export$7b401e46717c8af5(views, unit) {
    views.forEach((view)=>{
        if (typeof view.onUnitChange === 'function') view.onUnitChange(unit);
    });
}
function $cab22a0d6aee4804$export$a67294c8f97adfc6(views, result, model) {
    const { bmi: bmi, color: color, label: label, id: id, idealRange: idealRange, weightUnit: weightUnit, description: description, recommendations: recommendations } = result;
    const resultNumberEl = document.getElementById('result-number');
    const bmiValueEl = document.getElementById('bmi-value');
    if (resultNumberEl) resultNumberEl.classList.remove('hidden');
    if (bmiValueEl) {
        bmiValueEl.textContent = bmi;
        bmiValueEl.style.color = color;
    }
    const ageEl = document.getElementById('bmi-result-age');
    const idealWeightEl = document.getElementById('bmi-result-weight');
    const categoryEl = document.getElementById('bmi-result-desc-content');
    const descEl = document.getElementById('bmi-result-description');
    const recList = document.getElementById('recommendation-list');
    if (ageEl) {
        const age = model.getDetailedAge();
        ageEl.textContent = `${age.years} Years ${age.months} Months`;
    }
    if (idealWeightEl) idealWeightEl.textContent = `${idealRange.min} ${weightUnit} to ${idealRange.max} ${weightUnit}`;
    if (categoryEl) {
        categoryEl.textContent = label;
        categoryEl.style.color = color;
    }
    if (descEl) descEl.textContent = description;
    if (recList && recommendations?.length) {
        recList.innerHTML = '';
        recommendations.forEach((rec)=>{
            const li = document.createElement('li');
            li.className = 'mb-2';
            li.innerHTML = `<strong>${rec.title}:</strong> ${rec.description}`;
            recList.appendChild(li);
        });
    }
    $cab22a0d6aee4804$var$updateResultPath(id);
    $cab22a0d6aee4804$var$hideDefaultContent();
}
function $cab22a0d6aee4804$var$updateResultPath(categoryId) {
    const pathEl = document.getElementById('bmi-result-path');
    if (!pathEl) return;
    pathEl.querySelectorAll('.bmi-arrow').forEach((el)=>el.style.opacity = '0');
    const current = pathEl.querySelector(`[data-range="${categoryId}"]`);
    if (current) {
        const arrow = current.querySelector('.bmi-arrow');
        if (arrow) arrow.style.opacity = '1';
        current.classList.add('active');
    }
}
function $cab22a0d6aee4804$var$hideDefaultContent() {
    [
        'bmi-default-content',
        'result-default-title'
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.classList.add('hidden');
    });
    [
        'bmi-result-ideal',
        'bmi-result-desc'
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.classList.remove('hidden');
    });
}


function $11835fd92897c256$export$cd8687036809e662(fromUnit, toUnit, model) {
    const heightInput = document.getElementById('height-input');
    const weightInput = document.getElementById('weight-input');
    if (heightInput?.value) {
        const value = parseFloat(heightInput.value);
        heightInput.value = model.convertHeight(value, fromUnit, toUnit).toFixed(2);
    }
    if (weightInput?.value) {
        const value = parseFloat(weightInput.value);
        weightInput.value = model.convertWeight(value, fromUnit, toUnit).toFixed(2);
    }
}
function $11835fd92897c256$export$61b2ee974ad3248c(unit, model) {
    const heightLabel = document.querySelector('label[for="height-input"] h3');
    const weightLabel = document.querySelector('label[for="weight-input"] h3');
    const heightInput = document.getElementById('height-input');
    const weightInput = document.getElementById('weight-input');
    const heightUnit = model.getHeightUnit();
    const weightUnit = model.getWeightUnit();
    if (heightLabel) heightLabel.textContent = `Height (${heightUnit})`;
    if (weightLabel) weightLabel.textContent = `Weight (${weightUnit})`;
    if (heightInput) heightInput.placeholder = `Height in ${heightUnit}`;
    if (weightInput) weightInput.placeholder = `Weight in ${weightUnit}`;
}
function $11835fd92897c256$export$8c44e925997ad21b(unit) {
    const text = document.getElementById('unit-toggle-text');
    const btn = document.getElementById('unit-toggle-button');
    if (text && btn) {
        text.textContent = unit === 'metric' ? 'Switch to Imperial' : 'Switch to Metric';
        btn.dataset.currentUnit = unit;
    }
}



function $7968f12f685c0fda$export$d2452ec361ded837(model) {
    const bmi = model.calculateBMI();
    const category = model.getBMICategory();
    const idealRange = model.getIdealWeightRange();
    const details = (0, (/*@__PURE__*/$parcel$interopDefault($722ca2ee64e4098c$exports))).find((r)=>r.id === category.id);
    return {
        bmi: bmi.toFixed(1),
        label: category.label,
        color: category.color,
        id: category.id,
        age: model.age,
        unit: model.type,
        weightUnit: model.getWeightUnit(),
        heightUnit: model.getHeightUnit(),
        idealRange: {
            min: idealRange[0].toFixed(2),
            max: idealRange[1].toFixed(2)
        },
        description: details?.description || '',
        recommendations: details?.recommendation || []
    };
}


class $775206abde2f1855$export$cc449d075774ddef {
    #model = new (0, $3804779a567855a8$export$b95188dfbc2a51d)();
    #views = new Map();
    constructor(){
        this.#model.addObserver(this);
    }
    onModelChange = (prop, newVal, oldVal)=>{
        $46d5fd222f178ba4$export$e3169eee83556da4(this, this.#model, prop, newVal, oldVal);
    };
    registerView(name, view) {
        this.#views.set(name, view);
        if (view.bindModel) view.bindModel(this.#model);
    }
    unregisterView(name) {
        this.#views.delete(name);
    }
    updateHeight(value) {
        try {
            this.#model.height = value;
        } catch (err) {
            $1cfd5eadd7a35500$export$14802090cb9157a0(this.#views, 'height', err.message);
        }
    }
    updateWeight(value) {
        try {
            this.#model.weight = value;
        } catch (err) {
            $1cfd5eadd7a35500$export$14802090cb9157a0(this.#views, 'weight', err.message);
        }
    }
    updateAge(dob) {
        try {
            this.#model.setAgeFromDateOfBirth(dob);
        } catch (err) {
            $1cfd5eadd7a35500$export$14802090cb9157a0(this.#views, 'age', err.message);
        }
    }
    toggleUnit() {
        const from = this.#model.type;
        const to = from === 'metric' ? 'imperial' : 'metric';
        try {
            this.#model.convertToUnit(to);
            $11835fd92897c256$export$cd8687036809e662(from, to, this.#model);
            $11835fd92897c256$export$61b2ee974ad3248c(to, this.#model);
            $11835fd92897c256$export$8c44e925997ad21b(to);
            $cab22a0d6aee4804$export$7b401e46717c8af5(this.#views, to);
        } catch (err) {
            $1cfd5eadd7a35500$export$d3da1ecaf1206c58('Unit conversion failed', err);
        }
    }
    calculateBMI() {
        try {
            if (!this.#model.isDataComplete()) return $1cfd5eadd7a35500$export$227443268704debe('Please fill all fields.');
            if (!this.#model.isValid()) return $1cfd5eadd7a35500$export$227443268704debe('Invalid input values.');
            const result = (0, $7968f12f685c0fda$export$d2452ec361ded837)(this.#model);
            $cab22a0d6aee4804$export$a67294c8f97adfc6(this.#views, result, this.#model);
            return result;
        } catch (err) {
            $1cfd5eadd7a35500$export$d3da1ecaf1206c58('BMI calculation failed', err);
            return null;
        }
    }
}


class $2b6e161c9edcf319$var$BMIApplication {
    constructor(){
        this.controller = null;
        this.views = new Map();
        this.isInitialized = false;
    }
    async initialize() {
        try {
            this.#initializeController();
            this.#initializeViews();
            this.#setupLayout();
            this.#bindEvents();
            this.isInitialized = true;
        } catch (error) {
            console.error('Failed to initialize BMI Application:', error);
        }
    }
    #initializeController() {
        this.controller = new (0, $775206abde2f1855$export$cc449d075774ddef)();
        this.controller.onError = (error)=>{
            console.error('Controller error:', error);
        };
    }
    #initializeViews() {
        this.#createLayoutViews();
        this.#createApplicationViews();
    }
    #createLayoutViews() {
        const headerElement = document.getElementById('header');
        const footerElement = document.getElementById('footer');
        if (headerElement) {
            const headerView = (0, $9c3e0cdbb908598f$export$798e69447a57ffe5)(this.controller);
            headerElement.appendChild(headerView);
            this.views.set('header', headerView);
        }
        if (footerElement) {
            const footerView = (0, $731fa2aa36cb248b$export$7c88f7b87167f6)(this.controller);
            footerElement.appendChild(footerView);
            this.views.set('footer', footerView);
        }
    }
    #createApplicationViews() {
        this.#createFormView();
        this.#createResultView();
        this.#createInformationView();
    }
    #createFormView() {
        const formSection = document.getElementById('form-section');
        if (formSection) {
            const formView = (0, $11d472eb5a5cd0cc$export$33cde6b33eca4e5)(this.controller);
            formSection.appendChild(formView);
            this.views.set('form', formView);
        }
    }
    #createResultView() {
        const resultSection = document.getElementById('result-section');
        if (resultSection) {
            const resultView = (0, $07032ca19aac2ac1$export$33542b22e498cc2)(this.controller);
            resultSection.appendChild(resultView);
            this.views.set('result', resultView);
        }
    }
    #createInformationView() {
        const infoSection = document.getElementById('info-section');
        if (infoSection) {
            const infoView = (0, $ab9f30044e754e5e$export$463c3a0a10169cf8)(this.controller);
            infoSection.appendChild(infoView);
            this.views.set('information', infoView);
        }
    }
    #setupLayout() {
        this.#setupBMIContent();
        this.#setupMainContent();
    }
    #setupBMIContent() {
        const bmiContent = document.getElementById('bmi-content');
        if (bmiContent) bmiContent.classList.add('flex', 'flex-col', 'items-center', 'justify-center');
    }
    #setupMainContent() {
        const mainContent = document.getElementById('main-content');
        if (mainContent) mainContent.classList.add('flex', 'items-start', 'justify-center', 'flex-wrap', 'container', 'm-t-lg', 'gap-4');
    }
    #bindEvents() {
        this.#bindKeyboardEvents();
        this.#bindWindowEvents();
    }
    #bindKeyboardEvents() {
        document.addEventListener('keydown', (event)=>{
            if (event.ctrlKey || event.metaKey) switch(event.key){
                case 'Enter':
                    event.preventDefault();
                    this.controller.calculateBMI();
                    break;
                case 'u':
                    event.preventDefault();
                    this.controller.toggleUnit();
                    break;
            }
        });
    }
    #bindWindowEvents() {
        window.addEventListener('beforeunload', ()=>{
            this.#cleanup();
        });
    }
    #cleanup() {
        if (this.controller) this.views.forEach((view, name)=>{
            this.controller.unregisterView(name);
        });
        this.views.clear();
    }
}
const $2b6e161c9edcf319$var$bmiApp = new $2b6e161c9edcf319$var$BMIApplication();
document.addEventListener('DOMContentLoaded', ()=>{
    $2b6e161c9edcf319$var$bmiApp.initialize();
});
window.BMIApp = $2b6e161c9edcf319$var$bmiApp;


//# sourceMappingURL=path0.0bdf34a0.js.map
